export { IncodeDocumentCapture } from "./IncodeDocumentCapture";
